import React from 'react';

const Svg = ({ children, size = 24, stroke = 'currentColor', sw = 1.8, fill = 'none' }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={fill} stroke={stroke}
        strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {children}
    </svg>
);

export const IcCalendar = (p) => (
    <Svg {...p}><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></Svg>
);
export const IcAward = (p) => (
    <Svg {...p}><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></Svg>
);
export const IcPackage = (p) => (
    <Svg {...p}><path d="M16.5 9.4 7.55 4.24"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></Svg>
);
export const IcBuilding = (p) => (
    <Svg {...p}><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M9 22v-4h6v4"/><path d="M8 6h.01M16 6h.01M12 6h.01M12 10h.01M16 10h.01M8 10h.01M12 14h.01M16 14h.01M8 14h.01"/></Svg>
);
export const IcBook = (p) => (
    <Svg {...p}><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/></Svg>
);
export const IcHandshake = (p) => (
    <Svg {...p}><path d="m11 17 2 2a1 1 0 1 0 3-3"/><path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4"/><path d="m21 3 1 11h-2"/><path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"/><path d="M3 4h8"/></Svg>
);
export const IcBulb = (p) => (
    <Svg {...p}><path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5"/><path d="M9 18h6"/><path d="M10 22h4"/></Svg>
);
export const IcShield = (p) => (
    <Svg {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></Svg>
);
export const IcCompass = (p) => (
    <Svg {...p}><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></Svg>
);
export const IcNetwork = (p) => (
    <Svg {...p}><rect x="16" y="16" width="6" height="6" rx="1"/><rect x="2" y="16" width="6" height="6" rx="1"/><rect x="9" y="2" width="6" height="6" rx="1"/><path d="M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3"/><path d="M12 12V8"/></Svg>
);
export const IcChat = (p) => (
    <Svg {...p}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></Svg>
);
export const IcCube = (p) => (
    <Svg {...p}><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></Svg>
);
export const IcChart = (p) => (
    <Svg {...p}><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></Svg>
);
export const IcCloud = (p) => (
    <Svg {...p}><path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"/></Svg>
);
export const IcUsers = (p) => (
    <Svg {...p}><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></Svg>
);
export const IcDoc = (p) => (
    <Svg {...p}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="13" y2="17"/></Svg>
);
export const IcMonitor = (p) => (
    <Svg {...p}><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></Svg>
);
export const IcBrain = (p) => (
    <Svg {...p}><path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z"/><path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z"/><path d="M12 5v13"/></Svg>
);
export const IcFactory = (p) => (
    <Svg {...p}><path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M17 18h1M12 18h1M7 18h1"/></Svg>
);
export const IcArrowRight = (p) => (
    <Svg {...p}><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></Svg>
);
export const IcFlag = (p) => (
    <Svg {...p}><path d="M4 22V4a1 1 0 0 1 1-1h13l-4 6 4 6H5"/></Svg>
);

// 히어로 우측 데코 일러스트 (와이어프레임 큐브 + 격자 + 노드)
export const HeroCubeArt = ({ className = '' }) => (
    <svg className={className} viewBox="0 0 520 460" fill="none" aria-hidden="true">
        <defs>
            <linearGradient id="cubeStroke" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stopColor="#01BCD6" stopOpacity="0.9"/>
                <stop offset="1" stopColor="#0ea5e9" stopOpacity="0.25"/>
            </linearGradient>
            <radialGradient id="coreGlow" cx="50%" cy="50%" r="50%">
                <stop offset="0" stopColor="#01BCD6" stopOpacity="0.9"/>
                <stop offset="0.5" stopColor="#01BCD6" stopOpacity="0.25"/>
                <stop offset="1" stopColor="#01BCD6" stopOpacity="0"/>
            </radialGradient>
            <linearGradient id="gridLine" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0" stopColor="#01BCD6" stopOpacity="0"/>
                <stop offset="0.5" stopColor="#01BCD6" stopOpacity="0.35"/>
                <stop offset="1" stopColor="#01BCD6" stopOpacity="0"/>
            </linearGradient>
        </defs>
        {/* 배경 그리드 */}
        <g opacity="0.35">
            {Array.from({ length: 9 }).map((_, i) => (
                <line key={`h${i}`} x1="20" x2="500" y1={60 + i * 40} y2={60 + i * 40} stroke="url(#gridLine)" strokeWidth="0.6"/>
            ))}
            {Array.from({ length: 11 }).map((_, i) => (
                <line key={`v${i}`} y1="40" y2="420" x1={40 + i * 44} x2={40 + i * 44} stroke="url(#gridLine)" strokeWidth="0.6"/>
            ))}
        </g>
        {/* 글로우 코어 */}
        <circle cx="260" cy="230" r="170" fill="url(#coreGlow)"/>
        {/* 큐브 (외곽 → 내부 3겹) */}
        {[1, 0.78, 0.56, 0.34].map((s, i) => {
            const cx = 260, cy = 230;
            const w = 180 * s, h = 100 * s;
            return (
                <g key={i} opacity={0.5 + i * 0.12}>
                    <polygon
                        points={`${cx},${cy - h * 1.4} ${cx + w * 1.3},${cy - h * 0.4} ${cx + w * 1.3},${cy + h * 0.6} ${cx},${cy + h * 1.6} ${cx - w * 1.3},${cy + h * 0.6} ${cx - w * 1.3},${cy - h * 0.4}`}
                        stroke="url(#cubeStroke)" strokeWidth={1.4 - i * 0.2} fill="none"/>
                    <line x1={cx} y1={cy - h * 1.4} x2={cx} y2={cy + h * 1.6} stroke="url(#cubeStroke)" strokeWidth="0.8" opacity="0.6"/>
                    <line x1={cx - w * 1.3} y1={cy - h * 0.4} x2={cx + w * 1.3} y2={cy - h * 0.4} stroke="url(#cubeStroke)" strokeWidth="0.8" opacity="0.6"/>
                    <line x1={cx - w * 1.3} y1={cy + h * 0.6} x2={cx + w * 1.3} y2={cy + h * 0.6} stroke="url(#cubeStroke)" strokeWidth="0.8" opacity="0.6"/>
                </g>
            );
        })}
        {/* 중앙 노드 */}
        <circle cx="260" cy="230" r="6" fill="#01BCD6"/>
        <circle cx="260" cy="230" r="14" fill="none" stroke="#01BCD6" strokeWidth="1" opacity="0.6"/>
        {/* 외곽 노드 */}
        {[[80, 90], [440, 110], [110, 380], [430, 370], [260, 40], [260, 420]].map(([x, y], i) => (
            <g key={i}>
                <line x1={x} y1={y} x2="260" y2="230" stroke="#01BCD6" strokeWidth="0.6" opacity="0.35"/>
                <circle cx={x} cy={y} r="3" fill="#01BCD6" opacity="0.85"/>
                <circle cx={x} cy={y} r="7" fill="none" stroke="#01BCD6" strokeWidth="0.6" opacity="0.4"/>
            </g>
        ))}
    </svg>
);
